(function (angular) {
    'use strict';

    angular.module('broadcast')

        /**
         * 
         */
        .controller('BroadcastWizard', ['$timeout', '$scope', 'initialisedWizard', 'WizardHandler',
            function ($timeout, $scope, initialisedWizard, WizardHandler) {

                $scope.currentStepId = undefined;

                // window.onbeforeunload = function (e) {
                //     var dialogText = 'Dialog text here';
                //     e.returnValue = dialogText;
                //     return dialogText;
                // };

                $scope.bws = initialisedWizard;

                $scope.forms = {}

                /**
                 * Validate a single form
                 * @param {*} form 
                 */
                function _isStepValid(form) {
                    return form ? form.$valid : false;
                }

                /**
                 * * Validate a list of forms
                 * @param {*} forms 
                 */
                function _areStepsValid(forms) {
                    var validCount = 0;

                    angular.forEach(forms, function (form) {
                        var valid = _isStepValid(form);
                        if (valid) { validCount++ }
                    })
                    return validCount === forms.length;
                }

                $scope.canExitStep1 = function () {
                    return _isStepValid($scope.forms.step1Form) && ($scope.bws.step1Model.additionExitValidation ? $scope.bws.step1Model.additionExitValidation() : true);
                }

                $scope.canEnterStep1 = function () {
                    return true;
                }

                $scope.canExitStep2 = function () {
                    return _isStepValid($scope.forms.step2Form) && ($scope.bws.step2Model.additionExitValidation ? $scope.bws.step2Model.additionExitValidation() : true);
                }

                $scope.canExitStep3 = function () {
                    return _isStepValid($scope.forms.step3Form) && ($scope.bws.step3Model.additionExitValidation ? $scope.bws.step3Model.additionExitValidation() : true);
                }

                $scope.canExitStep4 = function () {
                    return _areStepsValid([$scope.forms.step3Form, $scope.forms.step4Form]) && ($scope.bws.step4Model.additionExitValidation ? $scope.bws.step4Model.additionExitValidation() : true);
                }

                $scope.canEnterStep2 = function () {
                    return _isStepValid($scope.forms.step1Form);
                }

                $scope.canEnterStep3 = function () {
                    return _areStepsValid([$scope.forms.step1Form, $scope.forms.step2Form]);
                }

                $scope.canEnterStep4 = function () {
                    return _areStepsValid([$scope.forms.step1Form, $scope.forms.step2Form, $scope.forms.step3Form]);
                }

                $scope.canEnterStep5 = function () {
                    return _areStepsValid([$scope.forms.step1Form, $scope.forms.step2Form, $scope.forms.step3Form, $scope.forms.step4Form]);
                }

                /**
                 * Dynamically generate title for step 1
                 */
                $scope.step1Title = function () {
                    return initialisedWizard.step1Model.name || "Broadcast Name";
                }

                /**
                 * Dynamically generate title for step 2
                 */
                $scope.step2Title = function () {

                    if (initialisedWizard.step2Model.messageParts && initialisedWizard.step2Model.messageParts.length) {
                        var heading;

                        if (initialisedWizard.step2Model.messageParts.length === 1) {
                            heading = "1 message";
                        } else {
                            heading = initialisedWizard.step2Model.messageParts.length + " messages";
                        }

                        var dets = "(";
                        angular.forEach(initialisedWizard.step2Model.messageParts, function (part, index) {
                            var result = part.type.split("/");
                            dets += result[0];
                            if (index !== initialisedWizard.step2Model.messageParts.length - 1) {
                                dets += ","
                            }
                        });

                        dets += ")";

                        return heading + "<br/>" + dets;
                    } else {
                        return "Compose Message";
                    }
                }

                /**
                 * Dynamically generate title for step 3
                 */
                $scope.step3Title = function () {
                    return initialisedWizard.step3Model.audienceId || "Choose Audience";
                }

                /**
                 * Dynamically generate title for step 4
                 */
                $scope.step4Title = function () {

                    if ($scope.canEnterStep4() && (initialisedWizard.step4Model.expiresAfter || initialisedWizard.step4Model.schedule)) {

                        var title = "";

                        if (initialisedWizard.step4Model.expiresAfter) {
                            title += '<span class="no-wrap"><i class="material-icons">done</i>Expiry<br/></span>';
                        }

                        if (initialisedWizard.step4Model.schedule) {
                            title += '<span><i class="material-icons">done</i> Schedule</span>';
                        }

                        return "<div class='text-left'>" + title + "</div>";

                    } else {
                        return "Send options";
                    }
                }

                $scope.step5Title = function () {
                    return "Send";
                }

                var firstTransition = true;

                $scope.$on('wizard:stepChanged', function (event, args) {

                    if (firstTransition) {
                        firstTransition = false;
                        goToLastPickedStep();
                    }
                    else if ($scope.currentStepId !== undefined && $scope.currentStepId !== args.index) {

                        localStorage.setItem("CurrentBroadcastInfo", JSON.stringify({
                            id: initialisedWizard.step1Model.id,
                            index: args.index
                        }));
                    }

                    $scope.currentStepId = args.index;
                });

                /**
                 * Internally, goTo() uses _isStepValid() so there is a race condition with $scope.forms being populated
                 * it is the templates loading asynchronously that causes the issue on staging and not dev.
                 * We will Watch $scope.forms intil all forms are populated prior to calling goTo()
                 */
                function goToLastPickedStep() {
                    var cbi = localStorage.getItem("CurrentBroadcastInfo");

                    if (cbi) {
                        cbi = JSON.parse(cbi);

                        if (cbi.id === initialisedWizard.step1Model.id) {

                            var unbindWatcher = $scope.$watch('forms', function (newForms, oldForms) {
                                if ($scope.forms.step1Form && $scope.forms.step2Form && $scope.forms.step3Form && $scope.forms.step4Form) {
                                    unbindWatcher();
                                    WizardHandler.wizard("broadcastWizard").goTo(cbi.index);
                                    $scope.currentStepId = cbi.index;
                                }
                            }, true);
                        }
                    }
                }

                // May be a bit harsh ...
                // $scope.$on('apiSpacesUpdate:picked', function () {
                //     $state.go('main.apiSpace.broadcast.existing');
                // });


            }]);

})(window.angular);